import React, {
  useEffect,
  useState,
  FunctionComponent,
  Suspense,
  lazy,
} from 'react';
import { useLocation } from '@reach/router';
import axios from 'axios';

import useWidgetQuery from '@bitcoin-portal/bitcoincom-pkg-components/dist/BuyWidgetV2/hooks/useWidgetQuery';

import { ProviderBaseProps } from '@bitcoin-portal/bitcoincom-pkg-components/dist/BuyWidgetV2/types';

import { activeEnv } from '../../data/constants';
import { DEFAULT_CRYPTO } from '../../constants';

const MoonpayWidget = lazy(
  () =>
    import(
      '@bitcoin-portal/bitcoincom-pkg-components/dist/BuyWidgetV2/ProviderWidgets/MoonpayWidget'
    ),
);
const OnRamperWidget = lazy(
  () =>
    import(
      '@bitcoin-portal/bitcoincom-pkg-components/dist/BuyWidgetV2/ProviderWidgets/OnRamperWidget'
    ),
);

interface ExtendedProps extends ProviderBaseProps {
  address: string;
  isSell?: boolean;
}

interface Props {
  provider?: string;
  // eslint-disable-next-line react/no-unused-prop-types
  crypto?: string;
}

const WidgetV2: FunctionComponent<Props> = ({
  provider,
  crypto: cryptoProp,
}) => {
  const { state, pathname, search } = useLocation();

  const [countryCode, setCountryCode] = useState('');

  const moonpaySupportCountry = [
    "AT", "BE", "BG", "CH", "CY", "CZ", "DE", "DK", "EE", "ES",
    "FI", "FR", "GR", "HR", "HU", "IE", "IS", "IT", "LT", "LU",
    "LV", "MT", "NL", "NO", "PL", "PT", "RO", "SE", "SI", "SK",
    "UK", "US", "GB"
  ]

  useEffect(() => {
    axios
      .get('https://neko-web.api.wallet.bitcoin.com/api/v1/location/info')
      .then(response => {
        if (response.data.countryCode) {
          setCountryCode(response.data.countryCode);
        }
      })
      .catch(err => {
        console.error('Error fetching geolocation:', err);
      });
  }, []);

  const query = useWidgetQuery(search);

  const queryOrState = { ...(state as ExtendedProps), ...query };

  const { crypto, amount, address, fiat, isSell } = queryOrState;

  const cryptoExtract = cryptoProp?.toUpperCase();

  const sell = pathname.endsWith('sell/') || isSell;

  const isBrowser = typeof window !== 'undefined';
  const externalTxId = JSON.stringify({
    host: isBrowser ? window.location.href : '',
    path: '/charlie',
    random: isBrowser ? window.crypto.randomUUID().split('-').pop() : '',
    timestamp: Date.now(),
  });

  return (
    <Suspense>
      {(provider === 'banxa' ||
        provider === 'alchemy' ||
        provider === 'simplex' ||
        provider === 'transak' ||
        provider === 'mercuryo' ||
        provider === 'usdc' ||
        provider === 'usdt') && (
        <OnRamperWidget
          crypto={cryptoExtract ?? crypto ?? DEFAULT_CRYPTO}
          amount={amount}
          fiat={fiat}
          provider={provider}
          isSell={sell}
          style={{ height: 650, border: 'none', width: '100%' }}
        />
      )}
      {provider === 'onrampmoney' && (
        <OnRamperWidget
          crypto={cryptoExtract ?? crypto ?? DEFAULT_CRYPTO}
          amount={amount}
          fiat={fiat}
          isSell={sell}
          style={{ height: 650, border: 'none', width: '100%' }}
        />
      )}
      {provider === 'moonpay' && (
        <MoonpayWidget
          env={activeEnv}
          address={address}
          crypto={cryptoExtract ?? crypto ?? DEFAULT_CRYPTO}
          amount={amount}
          fiat={fiat}
          isSell={sell}
        />
      )}
      {provider === 'charlie' && !moonpaySupportCountry.includes(countryCode) && (
        <OnRamperWidget
          crypto={cryptoExtract ?? crypto ?? DEFAULT_CRYPTO}
          amount={amount}
          fiat={fiat}
          isSell={sell}
          style={{ height: 650, border: 'none', width: '100%' }}
          partnerContext={externalTxId}
        />
      )}
      {provider === 'charlie' && moonpaySupportCountry.includes(countryCode) && (
        <MoonpayWidget
          env={activeEnv}
          address={address}
          crypto={cryptoExtract ?? crypto ?? DEFAULT_CRYPTO}
          amount={amount}
          fiat={fiat}
          isSell={sell}
          externalTransactionId={externalTxId}
        />
      )}
      {!provider && cryptoExtract === 'VERSE' && (
        <OnRamperWidget
          crypto={cryptoExtract ?? crypto ?? DEFAULT_CRYPTO}
          amount={amount}
          fiat={fiat}
          isSell={sell}
          style={{ height: 650, border: 'none', width: '100%' }}
        />
      )}
      {!provider && !moonpaySupportCountry.includes(countryCode) && cryptoExtract !== 'VERSE' && (
        <OnRamperWidget
          crypto={cryptoExtract ?? crypto ?? DEFAULT_CRYPTO}
          amount={amount}
          fiat={fiat}
          isSell={sell}
          style={{ height: 650, border: 'none', width: '100%' }}
        />
      )}
      {!provider && moonpaySupportCountry.includes(countryCode) && cryptoExtract !== 'VERSE' && (
        <MoonpayWidget
          env={activeEnv}
          address={address}
          crypto={cryptoExtract ?? crypto ?? DEFAULT_CRYPTO}
          amount={amount}
          fiat={fiat}
          isSell={sell}
        />
      )}
    </Suspense>
  );
};

export default WidgetV2;
